module.exports = __webpack_public_path__ + "eca711c0008dae30df855dc5a9572b17.jpg";